import React, {useState} from "react";
import {CardContent, CardHeader, CardActions, Button, Typography, Alert} from "@mui/material";
import {useDispatch} from "react-redux";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components/Cards/DialogCard";
import {Loader} from "../../../../../Components";
import {manualRun} from "../../Redux/Action";
import dayjs from "dayjs";

export const ConfirmGenerateModal = () => {

    const dispatch = useDispatch();
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const currentWeekStart = dayjs().startOf('week');
    const currentWeekEnd = dayjs().endOf('week');
    const weekNumber = dayjs().isoWeek();

    const handleSubmit = async () => {
        setIsLoading(true);
        setMessage('');
        await manualRun({ dispatch }).then((res) => {
            if(res?.success){
                setMessage(res.message || 'Roster generation job dispatched successfully');
                setStatus('success');
                dispatch(setModal({component: null, open: false}));
            } else {
                setMessage(res.message || 'Failed to dispatch roster generation job');
                setStatus('error');
            }
            setIsLoading(false);
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={"Confirm Roster Generation"}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                {message && (
                    <Alert severity={status} sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    You are about to generate the roster PDF for <strong>Week {weekNumber}</strong>:
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2, ml: 2 }}>
                    • <strong>Start Date:</strong> {currentWeekStart.format('dddd, MMMM DD, YYYY')}<br/>
                    • <strong>End Date:</strong> {currentWeekEnd.format('dddd, MMMM DD, YYYY')}
                </Typography>
                <Typography variant="body2" color="warning.main" sx={{ mb: 2 }}>
                    ⚠️ This will clear all previous failed attempts and start a fresh generation process.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Do you want to proceed?
                </Typography>
            </CardContent>
            <CardActions>
                <Button 
                    onClick={() => dispatch(setModal({component:null, open:false}))}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button 
                    disabled={isLoading} 
                    variant="contained" 
                    color={'primary'} 
                    onClick={handleSubmit}
                >
                    Generate Roster
                </Button>
            </CardActions>
        </DialogCard>
    )
}

